import { Box, Typography, TypographyProps, TypographyVariant } from "@mui/material"
import React from "react";

export type TextOverflowProps = {
    text: string;
    component?: React.ElementType;
    width?: string;
    maxWidth?: string | number;
    variant?: TypographyVariant
} & TypographyProps;

export const TextOverflow = ({
    text,
    component = "span",
    width = "100%",
    maxWidth = "unset",
    variant = "subtitle1",
    ...typographyProps
}: TextOverflowProps) => {
    return (
        <Box display="flex" flexGrow={1} minWidth={0}>
            <Typography
                variant={variant}
                component={component}
                noWrap
                sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                }}
                {...typographyProps}
            >
                {text}
            </Typography>
        </Box>
    );
}

export type TextOverflowWithIconProps = TextOverflowProps & {
    icon: React.ReactNode;
}

export const TextOverflowWithIcon = (props: TextOverflowWithIconProps) => {
    const { icon, ...textOverflowProps } = props;

    return (
        <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
            <Box sx={{ flexShrink: 0 }}>
                {icon}
            </Box>
            <TextOverflow {...textOverflowProps} />
        </Box>
    );
}